// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../rescript/lib/es6/curry.js";
import * as Caml_option from "../../../../rescript/lib/es6/caml_option.js";

function checkForEmptyString(string) {
  var match = string.trim();
  if (match === "") {
    return true;
  } else {
    return false;
  }
}

var nbsp = '\u0020';

function ignoreUnused(value) {
  
}

function tap(value, fn) {
  if (value !== undefined) {
    return Curry._1(fn, Caml_option.valFromOption(value));
  }
  
}

export {
  checkForEmptyString ,
  nbsp ,
  ignoreUnused ,
  tap ,
  
}
/* No side effect */
